import Service from "../Service";
import AuthService from "../AuthService";

const Auth = {
  login(data) {
    return Service.post("/api/admin-login", data).then((res) => {
      return res;
    });
  },
  verifyApprove(data) {
    return AuthService.post(
      `/api/research-approve/${data.researchID}`,
      data
    ).then((res) => {
      return res;
    });
  },
  verifyApproveRegen(data) {
    return AuthService.post(
      `/api/research-approve-regen/${data.researchID}`,
      data
    ).then((res) => {
      return res;
    });
  },
  approveRegenPost(data){
    return AuthService.post(`/api/research-approve-regen-post/${data.id}`, data).then((res) => {
      return res;
    })
  },
  getUser() {
    return AuthService.get("/api/show-profile").then((res) => res);
  },
  delete(id) {
    return AuthService.delete(`/api/delete-user/${id}`).then((res) => res);
  },
  register(data) {
    let formData = new FormData();
    formData.append("nameTitleID", data.nameTitleID ? data.nameTitleID : "");
    formData.append("rankID", data.rankID ? data.rankID : "");
    formData.append("preNameTh", data.preNameTh ? data.preNameTh : "");
    formData.append("preNameEn", data.preNameEn ? data.preNameEn : "");
    formData.append("thName", data.thName ? data.thName : "");
    formData.append("enName", data.enName ? data.enName : "");
    formData.append("thFirstName", data.thFirstName ? data.thFirstName : "");
    formData.append("enFirstName", data.enFirstName ? data.enFirstName : "");
    formData.append("thLastName", data.thLastName ? data.thLastName : "");
    formData.append("enLastName", data.enLastName ? data.enLastName : "");
    formData.append("mobilePhone", data.mobilePhone ? data.mobilePhone : "");
    formData.append("email", data.email ? data.email : "");
    formData.append("password", data.password ? data.password : "");
    formData.append(
      "password_confirmation",
      data.password_confirmation ? data.password_confirmation : ""
    );
    formData.append("gender", data.gender ? data.gender : "");
    formData.append("pictureFile", data.pictureFile ? data.pictureFile : "");
    formData.append(
      "signatureImage",
      data.signatureImage ? data.signatureImage : ""
    );
    formData.append("scMastery", data.scMastery ? data.scMastery : "");
    formData.append("scPosition", data.scPosition ? data.scPosition : "");
    formData.append("scTeam", data.scTeam ? data.scTeam : "");
    formData.append("otherScTeam", data.otherScTeam ? data.otherScTeam : "");
    formData.append(
      "scAffiliation",
      data.scAffiliation ? data.scAffiliation : ""
    );
    formData.append(
      "otherScMastery",
      data.otherScMastery ? data.otherScMastery : ""
    );
    formData.append(
      "otherScPosition",
      data.otherScPosition ? data.otherScPosition : ""
    );
    formData.append(
      "otherScAffiliation",
      data.otherScAffiliation ? data.otherScAffiliation : ""
    );
    formData.append("orderNumber", data.orderNumber ? data.orderNumber : "");
    formData.append("orderDate", data.orderDate ? data.orderDate : "");
    formData.append("isScientist", data.isScientist ? data.isScientist : "");
    formData.append("isAffiliated", data.isAffiliated ? data.isAffiliated : "");
    formData.append("training", JSON.stringify(data.training));
    formData.append("_method", "POST");
    return Service.post("/api/reviewer-register", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((res) => res);
  },
  adminRegister(data) {
    console.log(data);
    return AuthService.post("api/admin-register", data).then((res) => res);
  },
  adminUpdate(data) {
    return AuthService.post(`/api/admin-update`, data).then((res) => res);
  },
  updateProfile(data) {
    let formData = new FormData();
    formData.append("nameTitleID", data.nameTitleID ? data.nameTitleID : "");
    formData.append("rankID", data.rankID ? data.rankID : "");
    formData.append("preNameTh", data.preNameTh ? data.preNameTh : "");
    formData.append("preNameEn", data.preNameEn ? data.preNameEn : "");
    formData.append("thName", data.thName ? data.thName : "");
    formData.append("enName", data.enName ? data.enName : "");
    formData.append("thFirstName", data.thFirstName ? data.thFirstName : "");
    formData.append("enFirstName", data.enFirstName ? data.enFirstName : "");
    formData.append("thLastName", data.thLastName ? data.thLastName : "");
    formData.append("enLastName", data.enLastName ? data.enLastName : "");
    formData.append("mobilePhone", data.mobilePhone ? data.mobilePhone : "");
    formData.append("email", data.email ? data.email : "");
    formData.append("password", data.password ? data.password : "");
    formData.append(
      "password_confirmation",
      data.password_confirmation ? data.password_confirmation : ""
    );
    formData.append("gender", data.gender ? data.gender : "");
    formData.append("pictureFile", data.pictureFile ? data.pictureFile : "");
    formData.append(
      "signatureImage",
      data.signatureImage ? data.signatureImage : ""
    );
    formData.append(
      "signatureImageEN",
      data.signatureImageEN ? data.signatureImageEN : ""
    );
    formData.append("scMastery", data.scMastery ? data.scMastery : "");
    formData.append("scPosition", data.scPosition ? data.scPosition : "");
    formData.append("scTeam", data.scTeam ? data.scTeam : "");
    formData.append("otherScTeam", data.otherScTeam ? data.otherScTeam : "");
    formData.append(
      "scAffiliation",
      data.scAffiliation ? data.scAffiliation : ""
    );
    formData.append(
      "otherScMastery",
      data.otherScMastery ? data.otherScMastery : ""
    );
    formData.append(
      "otherScPosition",
      data.otherScPosition ? data.otherScPosition : ""
    );
    formData.append(
      "otherScAffiliation",
      data.otherScAffiliation ? data.otherScAffiliation : ""
    );
    formData.append("orderNumber", data.orderNumber ? data.orderNumber : "");
    formData.append("orderDate", data.orderDate ? data.orderDate : "");
    formData.append("isScientist", data.isScientist ? data.isScientist : "");
    formData.append("isAffiliated", data.isAffiliated ? data.isAffiliated : "");
    formData.append("training", JSON.stringify(data.training));
    formData.append("_method", "POST");
    return AuthService.post(`/api/update-reviewer/${data.id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((res) => res);
  },
};

export default Auth;
